module.exports = __webpack_public_path__ + "static/media/background-dark-mobile.4b1d6528.webp";